// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Constants
import { PARTNER_OPTION_DEFAULT } from 'ChartApp/ts/features/charts-shared/constants';
// Actions
import { setFundChartPartner } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/partner/partner.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const partner = createReducer(PARTNER_OPTION_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.partner), on(setFundChartPartner, (state, action) => action.partner));
